export default __webpack_public_path__ + "static/media/damage2.edbc697a.png";